import { render, staticRenderFns } from "./organGroupDialog.vue?vue&type=template&id=e37c7ea2"
import script from "./organGroupDialog.vue?vue&type=script&lang=js"
export * from "./organGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./organGroupDialog.vue?vue&type=style&index=0&id=e37c7ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports